import { useUsersContext } from 'contexts/UsersContext';

import { Headline } from 'components/Headline';
import { TabType, Tabs } from 'components/Tabs';

import * as S from './Manage.styles';

type ManageProps = {
  title: string;
  tabs: TabType[];
  isNew?: boolean;
};

export function Manage({ title, tabs }: ManageProps): React.ReactElement {
  const { onSubmit } = useUsersContext();

  return (
    <S.Container>
      <S.Header>
        <Headline fontWeight="bold" fontFamily="LFT Zeno Condensed" scale="xl" color="black">
          {title}
        </Headline>
      </S.Header>

      <S.Tabs>
        <Tabs saveUser={onSubmit} tabs={tabs} />
      </S.Tabs>
    </S.Container>
  );
}
